import { render, staticRenderFns } from "./BaseCardColor.vue?vue&type=template&id=6843af24&scoped=true&"
import script from "./BaseCardColor.vue?vue&type=script&lang=js&"
export * from "./BaseCardColor.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardColor.vue?vue&type=style&index=0&id=6843af24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843af24",
  null
  
)

export default component.exports